import React from 'react';
import { Star } from 'lucide-react';
import { getScoreColorClass } from '../lib/constants';

const STAR_RATINGS = [1, 2, 3, 4, 5];

const SIZE_CLASSES = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

const SCORE_SIZE_CLASSES = {
  sm: 'w-10 h-10 text-sm',
  md: 'w-14 h-14 text-lg',
  lg: 'w-20 h-20 text-2xl',
};

export const StarRating = ({ rating, onRate, size = 'md', readonly = false }) => {
  const handleClick = (star) => {
    if (!readonly && onRate) {
      onRate(star);
    }
  };

  return (
    <div className="star-rating flex gap-1" data-testid="star-rating">
      {STAR_RATINGS.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => handleClick(star)}
          disabled={readonly}
          className={`p-0 border-0 bg-transparent ${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-125'} transition-transform duration-200`}
          data-testid={`star-${star}`}
          aria-label={`Rate ${star} stars`}
        >
          <Star
            className={`${SIZE_CLASSES[size]} ${
              star <= rating ? 'fill-[#d4af37] text-[#d4af37]' : 'text-stone-600 hover:text-stone-500'
            } transition-colors`}
          />
        </button>
      ))}
    </div>
  );
};

export const WineScore = ({ score, size = 'md' }) => {
  return (
    <div
      className={`score-circle ${SCORE_SIZE_CLASSES[size]} ${getScoreColorClass(score)} rounded-full border-2 flex items-center justify-center font-serif font-semibold`}
      data-testid="wine-score"
    >
      {Math.round(score)}
    </div>
  );
};
